<template>
    <div v-if="isLoading" class="loading-overlay"><p>Acessando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlert" :mensagem="msgAlert" />

    <div class="content-row">
        <div class="content-data">
            <div class="form-edit-page">
                <div class="row row-space">
                    <div class="form-item" style="flex: 0 0 90px;">
                        <label class="label-caption">Solicitação</label>
                        <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.cdipossolicitacao) }}</div>
                    </div>

                    <div class="form-item form-item-data">
                        <label class="label-caption">Data</label>
                        <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtsolicitacao) }}</div>
                    </div>

                    <div class="form-item">
                        <label class="label-caption">Tipo Serviço</label>
                        <div class="field-label">{{ objView.nmipservico }}</div>
                    </div>

                    <div class="form-item" style="flex: 0 0 220px;">
                        <label class="label-caption">Situação</label>
                        <div class="field-label field-label-center">{{ objView.statusnm }}</div>
                    </div>
                </div>


                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Solicitante</label>
                        <div class="field-label">{{ objView.nmpessoa }}</div>
                    </div>
                    
                    <div class="form-item-char20">
                        <label class="label-caption">Fone</label>
                        <div class="field-label field-label-center">{{ objView.fone }}</div>
                    </div>

                    <div class="form-item" style="flex: 0 0 220px;">
                        <label class="label-caption">Coordenadas</label>
                        <div class="field-label field-label-center">{{ objView.latitude }} x {{ objView.longitude }}</div>
                    </div>
                </div>


                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Bairro</label>
                        <div class="field-label">{{ objView.nmbairro }}</div>
                    </div>

                    <div class="form-item ">
                        <label class="label-caption">Logradouro</label>
                        <div class="field-label">{{ objView.nmlogradouro }}</div>
                    </div>

                    <div class="form-item">
                        <label class="label-caption">Referência</label>
                        <div class="field-label">{{ objView.referencia }}</div>
                    </div>
                </div>


                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">Detalhamento</label>
                        <div class="field-label">{{ objView.detalhamento }}</div>
                    </div>            
                </div>


                <div class="row-end">
                    <button v-if="!objView.nmlogradouro" type="button" @click="setarEndereco">Ler Endereço</button>
                    <button v-if="objView.status==1" type="button" class="btn-confirm" @click="gerarOS">Gerar OS</button>
                    <button v-if="objView.status==1" type="button" class="btn-cancel" @click="showModalJustificativa=true">Reprovar</button>
                    <button type="button" @click="closeForm">Retornar</button>
                </div>
            </div>
        </div>

        <div v-if="imageSrc" class="content-foto">
            <div class="form-edit-page">
                <div v-if="imageSrc">
                    <img :src="imageSrc" alt="Imagem carregada" @click="showModalImage = true" />
                </div>
            </div>
        </div>
    </div>


    <div>
        <ImageModal v-if="showModalImage" :imageSrc="imageSrc" :visible="showModalImage" @close="showModalImage=false" />
    </div>
    

    <div v-if="showMap && !showModalImage" class="margin-top10">
        <MapComponent :latitude="objView.latitude" :longitude="objView.longitude" />
    </div>

    <div>
        <ModalJustificativa
            :visible="showModalJustificativa"
            @update:visible="(value) => (showModalJustificativa = value)"
            @submit="anularSolicitacao" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericGet, genericPost, genericPut } from '@/funcoes/api';
import { globalStore } from '@/globals';
import ImageModal from '@/components/modals/ImageModal.vue';
import MapComponent from '@/components/MapComponent.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import ModalJustificativa from '@/components/modals/ModalJustificativa.vue';

const emit = defineEmits(['close','save']);
const props = defineProps({idView: {type: Number, default: 0}});

const ckEmitSave = ref(false);
const imageSrc = ref(null);
const isLoading = ref(false);
const msgAlert = ref(null);
const objView = ref({});
const showMap = ref(false);
const showModalImage = ref(false);
const showModalJustificativa = ref(false);

const anularSolicitacao = async({justificativa}) => {
    try{
        msgAlert.value=null;
        isLoading.value=true;
        const r = await genericPut('/cad/ipos_solicitacao', {
            id: objView.value.id, 
            lganulacao: globalStore.idlogin, 
            obanulacao: justificativa});
        if (r.bolok==1){
            emit('close');
            emit('save');
        }else{msgAlert.value=r.erro}
    }catch (error){msgAlert.value=error;
    }finally{isLoading.value=false;}
}

const closeForm = () => {if (ckEmitSave.value){emit('save')} emit('close')}

const gerarOS = async() => {
    try{
        msgAlert.value=null;
        isLoading.value=true;
        const r = await genericPost('/ip/ipossolicitacoes/gera_os', {id: objView.value.id, idusuario: globalStore.idusuario});
        if (r.bolok==1){
            emit('close');
            emit('save');
        }else{msgAlert.value=r.erro}
    }catch (error){msgAlert.value=error;
    }finally{isLoading.value=false;}
}

const lerDados = async() => {
    try{
        msgAlert.value=null;
        isLoading.value = true;
        const req = await genericPost('/ip/ipossolicitacoes', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);
        showMap.value = ((objView.value) && (objView.value.latitude) && (objView.value.longitude));

        // LISTA DE ANEXOS  --  MOSTRANDO APENAS O PRIMEIRO
        const lsImagens = await genericPost('/ip/ipossolicitacoes/anexos', {idmunicipio: globalStore.idmunicipio, id: objView.value.id});
        if (lsImagens.length > 0){
            const reqFoto = await genericGet('/main/anexo_view_base64', {id: lsImagens[0].idanexo});
            if (reqFoto){
                imageSrc.value = `data:image/jpeg;base64,${reqFoto.anexo}`;
            }
        }
    }catch (error){msgAlert.value=error;
    }finally{isLoading.value = false;}
}

const setarEndereco = async() => {
    try{
        msgAlert.value=null;
        isLoading.value = true;
        const req = await genericPost('/ip/ipossolicitacoes/processar/coordenadas', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        if (req.bolok==1){
            ckEmitSave.value=true;
            await lerDados();
        }else{msgAlert.value=req.erro}
    }catch (error){msgAlert.value=error;
    }finally{isLoading.value = false;}
}

onMounted(lerDados);
</script>

<style scoped>
.content-row{
    display: flex;
    gap: 10px;
}
.content-data{
    flex: 1;
}
.content-foto{
    width: 300px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}
.content-foto img{
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
}
</style>